import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import { TypeAsserter } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import * as me from '../../me'
import * as entities from '../entities'
import * as snapshots from '../snapshots'

import { Api } from './api.service'
import type { Context, TypeParams } from './types'

@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    const entitiesEc = ngCore.inject(entities.Collection)
    const snapshotsEc = ngCore.inject(snapshots.Collection)

    super({
      api: ngCore.inject(Api),
      context$: rxjs
        .combineLatest({
          // NOTE: Uncomment and modify when dimension attributes need to be displayed
          // dimensionId:
          //   dimensionsEc.plugins.currentEntityPlugin.feature.selectors.getId()
          //     .asObservable,
          entityId:
            entitiesEc.plugins.currentEntityPlugin.feature.selectors.getId()
              .asObservable,
          snapshotId:
            snapshotsEc.plugins.currentEntityPlugin.feature.selectors.getId()
              .asObservable,
          zoneContext: ngCore.inject(me.Feature).contexts.selectors.zoneContext
            .asObservable,
        })
        .pipe(
          rxjs.map(({ zoneContext, entityId, snapshotId }): Context => {
            if (!zoneContext) {
              return undefined
            }

            return entityId
              ? {
                  ...zoneContext,
                  modelId: TypeAsserter.validateButJustWarn(
                    entityId,
                    ents.core.dms.models.Entity.Id.assertIsId,
                  ),
                }
              : snapshotId
                ? {
                    ...zoneContext,
                    modelId: TypeAsserter.validateButJustWarn(
                      snapshotId,
                      ents.core.dms.models.Snapshot.Id.assertIsId,
                    ),
                  }
                : undefined
          }),
        ),
      identify: entity => entity.id,
      name: ec.Name.Predefined.DmsAttribute,
      plugins: {
        additionalFactories: [new ds.table.ec.Factory<TypeParams>()],
      },
    })
  }
}
